import { Component, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';

import { startWith, switchMap } from 'rxjs';

import { THUMBS_4_OPTIONS } from '@core/evaluations-util';
import type { RatingThumbLevel } from '@core/evaluations-util';
import { TranslatePipe } from '@core/i18n-legacy';
import type { RatingLevelType } from '@core/interview-results-types';
import { IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-rating-buttons',
  templateUrl: './evaluation-rating-buttons.component.html',
  styleUrls: ['./evaluation-rating-buttons.component.less'],
  imports: [IconComponent, RtTooltip, TranslatePipe],
})
export class EvaluationRatingButtonsComponent {
  protected readonly options = THUMBS_4_OPTIONS;

  public readonly control = input.required<FormControl<RatingLevelType | null>>();

  protected value = toSignal(
    toObservable(this.control).pipe(
      switchMap(control => control.valueChanges.pipe(startWith(control.value))),
    ),
    { initialValue: null },
  );

  protected select(level: RatingThumbLevel): void {
    const control = this.control();
    const rating = <RatingLevelType>level;

    control.setValue(control.value === rating ? null : rating);
    control.markAsDirty();
    control.markAsTouched();
  }
}
